module.exports = __webpack_public_path__ + "img/album14_25.0c9fe22b.jpg";